import { create } from "zustand";
import { demoUser, DEMO_SESSION_TOKEN } from "@/lib/data/user";

const stored = typeof window !== "undefined" ? window.localStorage.getItem("aviando-session") : null;

export const useAuthStore = create((set) => ({
  sessionToken: stored,
  user: stored ? demoUser : null,
  loginDemo: () => {
    window.localStorage.setItem("aviando-session", DEMO_SESSION_TOKEN);
    set({ sessionToken: DEMO_SESSION_TOKEN, user: demoUser });
  },
  logout: () => {
    window.localStorage.removeItem("aviando-session");
    set({ sessionToken: null, user: null });
  },
}));
